/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import FormRenderer from '../../../../framework/Inputs/formRenderer/formRenderer';
import { connect } from 'react-redux';
import { shipmentMovementOptions, reasonOptions, documentCode } from '../../../../utils/constants/constants';
import CommodityDetails from '../clearanceDeclaration/commodityDetails/commodityDetails';
import './clearanceDeclaration.scss';
import { CLERANCE_DECLARATION } from '../../../../utils/constants/constants';

const ClearanceDeclaration = (props) => {
  const {
    formField: {
      shipmentMovement,
      clearanceTotalValue,
      descriptionOfGoods,
      receipentUKIMS,
      receipentEORI,
      shipperUKIMS,
      shipperEORI,
      shippingCharges,
      reasonExport,
      shipperDeferment,
      clearanceDescriptionGoods,
      collectionPointUKIMSNumber,
      collectionPointEORINumber,
      currency
    },
    formikValues,
    setFieldValue,
    isCarriageForward,
    clearanceDecleration,
    populateClearance,
    applyPadding,
    isCollectionRequest,
    isReturnToSender,
    shipmentDetails,
    selectedAccount,
    isSendToThirdParty,
    errors,
  } = props;

  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    if (populateClearance) {
      if (
        clearanceDecleration.accountNumber === selectedAccount?.accountId &&
        !formikValues?.accountNumber?.customsRegistration?.hasOwnProperty('ukimsNumber')
      ) {
        setFieldValue('shipperEORI', clearanceDecleration?.sendersEORINumber || '');
        setFieldValue('shipperDeferment', clearanceDecleration?.sendersDefermentAccount || '');
        setFieldValue('shipperUKIMS', clearanceDecleration?.sendersUKIMSNumber || '');
      } else if (shipmentDetails) {
        setFieldValue('shipperUKIMS', shipmentDetails?.shipperUKIMS || '');
        setFieldValue('shipperDeferment', shipmentDetails?.shipperDeferment || '');
        setFieldValue('shipperEORI', shipmentDetails?.shipperEORI || '');
      } else {
        setFieldValue('shipperUKIMS', formikValues?.accountNumber?.customsRegistration?.ukimsNumber || '');
        setFieldValue(
          'shipperDeferment',
          formikValues?.accountNumber?.customsRegistration?.defermentAccountNumber || '',
        );
        setFieldValue('shipperEORI', formikValues?.accountNumber?.customsRegistration?.eoriNumber || '');
      }
    } else {
      if (formikValues?.accountNumber?.accountId !== selectedAccount?.accountId) {
        setFieldValue('shipperUKIMS', formikValues?.accountNumber?.customsRegistration?.ukimsNumber || '');
        setFieldValue(
          'shipperDeferment',
          formikValues?.accountNumber?.customsRegistration?.defermentAccountNumber || '',
        );
        setFieldValue('shipperEORI', formikValues?.accountNumber?.customsRegistration?.eoriNumber || '');
      } else if (shipmentDetails) {
        setFieldValue('shipperUKIMS', shipmentDetails?.shipperUKIMS || '');
        setFieldValue('shipperDeferment', shipmentDetails?.shipperDeferment || '');
        setFieldValue('shipperEORI', shipmentDetails?.shipperEORI || '');
      } else {
        setFieldValue('shipperUKIMS', formikValues?.accountNumber?.customsRegistration?.ukimsNumber || '');
        setFieldValue(
          'shipperDeferment',
          formikValues?.accountNumber?.customsRegistration?.defermentAccountNumber || '',
        );
        setFieldValue('shipperEORI', formikValues?.accountNumber?.customsRegistration?.eoriNumber || '');
      }
    }
  }, [formikValues.shipmentMovement, formikValues.accountNumber]);
  useEffect(() => {
    if (populateClearance) {
      shipmentMovementOptions.map((shipmentMovementOption, index) => {
        if (clearanceDecleration?.shipmentMovementType == shipmentMovementOption.name) {
          setFieldValue('shipmentMovement', shipmentMovementOptions[index]);
        }
      });
      const itemData = clearanceDecleration?.items?.map((obj) => {
        const selectedCountry = clearanceDecleration?.itemCountry.filter((country) => {
          return obj?.countryOfManufacture == country?.code2Digit;
        });
        return {
          commodityCode: obj?.commodityCode || '',
          countryOfOrigin: selectedCountry[0],
          fullDescriptionOfGoods: obj?.descriptionOfGoods || '',
          quantity: obj?.unitQuantity || '',
          unitValue: obj?.unitValue || '',
          unitWeight: obj?.unitWeight || '',
          ddsReferenceNumber: obj?.eudr?.ddsReferenceNumber || '',
          documentCode:
            documentCode.find((option) => option.value.split(/\s+/)[0] === obj?.eudr?.documentCode) || '',
        };
      });
      setFieldValue('descriptionOfGoods', clearanceDecleration?.descriptionOfGoodsShipment || '');
      setFieldValue('clearanceTotalValue', clearanceDecleration?.totalValue || '');
      setFieldValue('receipentUKIMS', clearanceDecleration?.recipientUKIMSNumber || '');
      setFieldValue('receipentEORI', clearanceDecleration?.recipientEORINumber || '');
      setFieldValue('shipperUKIMS', clearanceDecleration?.sendersUKIMSNumber || '');
      setFieldValue('shipperEORI', clearanceDecleration?.sendersEORINumber || '');
      setFieldValue('shippingCharges', clearanceDecleration?.shippingCharges ?? '');
      setFieldValue('shipperDeferment', clearanceDecleration?.sendersDefermentAccount || '');
      setFieldValue('clearanceDescriptionGoods', clearanceDecleration?.descriptionOfGoodsShipment || '');
      setFieldValue('commodityDetails', itemData);
      setFieldValue('collectionPointUKIMSNumber', clearanceDecleration?.collectionPointUKIMSNumber || '');
      setFieldValue('collectionPointEORINumber', clearanceDecleration?.collectionPointEORINumber || '');
      reasonOptions.map((reasonOption, index) => {
        if (clearanceDecleration?.reasonForExport == reasonOption.value) {
          setFieldValue('reasonExport', reasonOptions[index]);
        }
      });
    }
  }, [clearanceDecleration, populateClearance]);

  const style = applyPadding ? { paddingRight: '38px' } : {};
  const goodsDescription = isCollectionRequest ? clearanceDescriptionGoods : descriptionOfGoods;
  const {
    MOVEMENT_TYPE_B2B_VALUE,
    MOVEMENT_TYPE_C2C_VALUE,
    MOVEMENT_TYPE_C2B_VALUE,
    MOVEMENT_TYPE_B2C_VALUE,
    CURRENCY_DATA
  } = CLERANCE_DECLARATION;

  const filteredShipmentMovementOptions = isReturnToSender
    ? shipmentMovementOptions.filter(
        (option) => option.value === MOVEMENT_TYPE_B2B_VALUE || option.value === MOVEMENT_TYPE_C2B_VALUE,
      )
    : isSendToThirdParty
    ? shipmentMovementOptions.filter((option) => option.value !== MOVEMENT_TYPE_C2C_VALUE)
    : shipmentMovementOptions;

  // To handle validation while using TOoltip  
  const handleBlur = () => {
    setIsTouched(true);
  };

  return (
    <div className={`wd-100 ${isReturnToSender ? 'return-to-sender' : ''}`}>
      <Grid
        container
        spacing={3}
        direction="row"
        alignItems="flex-start"
        style={{ paddingTop: '0px' }}
        className={isReturnToSender ? 'manage-spacing' : ''}
      >
        <Grid
          item
          xs={12}
          sm={4}
          md={isCarriageForward ? 12 : 6}
          style={style}
          className={isReturnToSender ? 'set-width' : ''}
        >
          <FormRenderer {...shipmentMovement.props} fullWidth data={filteredShipmentMovementOptions} />
        </Grid>
      </Grid>
      {formikValues.shipmentMovement?.value && (
        <>
          <Grid container spacing={3} direction="row" className="set-padding-dropdown" alignItems="flex-start">
            {formikValues.shipmentMovement?.value === MOVEMENT_TYPE_C2C_VALUE && (
              <Grid item xs={12} sm={12} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                <FormRenderer {...goodsDescription.props} fullWidth />
              </Grid>
            )}
            <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
              <FormRenderer {...clearanceTotalValue.props} fullWidth />
            </Grid>
            <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
              <FormRenderer {...currency.props} fullWidth data={CURRENCY_DATA} isDisabled={true}/>
            </Grid>
          </Grid>

          {formikValues.shipmentMovement?.value === MOVEMENT_TYPE_C2B_VALUE &&
            !isSendToThirdParty &&
            !isReturnToSender && (
              <Grid container spacing={3} direction="row" className="set-padding-dropdown" alignItems="flex-start">
                <Grid item xs={12} sm={12} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                  {isReturnToSender ? (
                    <Tooltip title={formikValues.receipentUKIMS}>
                      <FormRenderer {...receipentUKIMS.props} fullWidth />
                    </Tooltip>
                  ) : (
                    <FormRenderer {...receipentUKIMS.props} fullWidth />
                  )}
                </Grid>
                <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                  <FormRenderer {...receipentEORI.props} fullWidth />
                </Grid>
              </Grid>
            )}
          {formikValues.shipmentMovement?.value === MOVEMENT_TYPE_B2C_VALUE && !isSendToThirdParty && (
            <Grid container spacing={3} direction="row" className="set-padding-dropdown" alignItems="flex-start">
              <Grid item xs={12} sm={12} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                {isReturnToSender ? (
                  <Tooltip title={formikValues.shipperUKIMS}>
                    <FormRenderer {...shipperUKIMS.props} fullWidth isDisabled= {true}/>
                  </Tooltip>
                ) : (
                  <FormRenderer {...shipperUKIMS.props} fullWidth isDisabled= {true} />
                )}
              </Grid>
              <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                <FormRenderer {...shipperEORI.props} fullWidth  isDisabled= {true}/>
              </Grid>
            </Grid>
          )}

          {formikValues.shipmentMovement?.value === MOVEMENT_TYPE_B2B_VALUE && (
            <Grid container spacing={3} direction="row" className="set-padding-dropdown" alignItems="flex-start">
              <Grid item xs={12} sm={12} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                {isReturnToSender ? (
                  <Tooltip title={formikValues.shipperUKIMS}>
                    <FormRenderer {...shipperUKIMS.props} fullWidth isDisabled= {true}/>
                  </Tooltip>
                ) : (
                  <FormRenderer {...shipperUKIMS.props} fullWidth isDisabled= {true} />
                )}
              </Grid>
              <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                <FormRenderer {...shipperEORI.props} fullWidth isDisabled= {true}/>
              </Grid>
              {isReturnToSender ? null : (
                <>
                  <Grid item xs={12} sm={12} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    {isReturnToSender ? (
                      <Tooltip title={formikValues.receipentUKIMS}>
                        <FormRenderer {...receipentUKIMS.props} fullWidth />
                      </Tooltip>
                    ) : (
                      <FormRenderer {...receipentUKIMS.props} fullWidth />
                    )}
                  </Grid>
                  <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    <FormRenderer {...receipentEORI.props} fullWidth />
                  </Grid>
                </>
              )}

              {(isSendToThirdParty || isReturnToSender) && (
                <>
                  <Grid item xs={12} sm={12} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    {isReturnToSender ? (
                      <Tooltip title={formikValues.collectionPointUKIMSNumber}>
                       <FormRenderer
                            {...collectionPointUKIMSNumber.props}
                            fullWidth
                            error={isTouched && Boolean(errors.collectionPointUKIMSNumber)}
                            helperText={isTouched && errors.collectionPointUKIMSNumber}
                            onBlur={handleBlur}
                          />
                      </Tooltip>
                    ) : (
                      <FormRenderer {...collectionPointUKIMSNumber.props} fullWidth />
                    )}
                  </Grid>
                  <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    <FormRenderer {...collectionPointEORINumber.props} fullWidth />
                  </Grid>
                </>
              )}
            </Grid>
          )}
           {formikValues.shipmentMovement?.value !== MOVEMENT_TYPE_C2C_VALUE && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <CommodityDetails
                {...props}
                shipmentMovementType={formikValues.shipmentMovement?.value}
                isCollectionRequest={isCollectionRequest}
                isEU={formikValues.destinationCountry?.isEU}
                isAddressBook={props.isAddressBook}
              />
            </Grid>
          )}
          {!formikValues?.receipentUKIMS &&
            !formikValues?.shipperUKIMS &&
            !formikValues?.collectionPointUKIMSNumber &&
            formikValues.shipmentMovement?.value == MOVEMENT_TYPE_B2B_VALUE && (
              <>
                <Grid container spacing={3} direction="row" className="set-padding-lane" alignItems="flex-start">
                  <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    <FormRenderer {...shippingCharges.props} fullWidth />
                  </Grid>
                  <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    <FormRenderer {...reasonExport.props} data={reasonOptions} fullWidth />
                  </Grid>
                  <Grid item xs={10} sm={6} md={6} className={!isReturnToSender ? 'set-padding' : ''}>
                    <FormRenderer {...shipperDeferment.props} fullWidth   isDisabled= {true}/>
                  </Grid>
                </Grid>
              </>
            )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loadedFrom: state.loadedFrom.loadedFrom,
    shipmentDetails: state.addShipmentData.shipmentDetails,
    selectedAccount: state.accounts.selectedAccount,
  };
};

export default connect(mapStateToProps, null)(ClearanceDeclaration);
